<template>
	<div v-if="getConvertedText || getEmptyBodyWithURL" :class="{ 'text-right': !message.Inbound }" style="margin-bottom: 10px;">
		<div class="user-chat-info">
			<div class="message-layout-box">
				<!-- <p class="blue" style="margin: 0px;">
					Lorem, ipsum dolor sit amet consectetur adipisicing elit. Temporibus iusto soluta perferendis.
				</p> -->
				<!-- <p class="blue" style="margin: 0px;"> -->
			<div class="rounded text-left message1" style="margin: 4px;" v-bind:class="getColorStyle">
			<div v-if="message.ErrorCode" style="float: right;color: white;cursor: pointer" @click="deleteErrorMessage">X</div>
			<div v-if="hasMediaUrl">
				<a v-if="isImage" style="display:block;text-decoration: none" target="blank"  :href="message.mediaUrl" >
					<img width="250" :src="message.mediaUrl"/>
				</a>
				<a v-if="isAudio" style="display:block;text-decoration: none" target="blank"  :href="message.mediaUrl" >
					<v-icon scale="2.5" name="music" />
				</a>
				<a v-if="isVideo" style="display:block;text-decoration: none" target="blank"  :href="message.mediaUrl" >
					<v-icon scale="2.5" name="video" />
				</a>
				<a v-if="isDocument" style="display:block;text-decoration: none" target="blank"  :href="message.mediaUrl" >
					<v-icon scale="2.5" name="file" />
				</a>
			</div>
			
			<span style="word-break: break-word; word-wrap: break-word" v-html="getConvertedText"></span>
			<div v-if="checkIfEmailData" class="d-flex align-items-center custom-email-button">
				<div class="email-icon">
					<v-icon name="envelope" scale="3"  :class="getClassName"/>
				</div>
				<b-button  variant="primary" @click="$emit('openEmailM', message,'withDetails')">{{checkIfEmailData}} </b-button>
			</div>

			<!-- <span style="word-break: break-word; word-wrap: break-word" v-html="getConvertedText"></span> -->
			<div v-if="checkIfCallsData" class="d-flex align-items-center custom-email-button">
					<div class="email-icon">
						<v-icon name="phone-square-alt" scale="3"  :class="getClassName"/>
					</div>
					<b-button  variant="primary" @click="$emit('openCallM', message,'withDetails')">{{checkIfCallsData}} </b-button>
			</div>
			<div class="d-flex align-items-center custom-email-button" style="text-decoration:underline;cursor: pointer" v-if="this.message.Auto"> 
				<b-button class="p-0 error" variant="outline" @click="toggleRatingField(true)" 
				v-b-tooltip.hover id="ratingButton">Send</b-button>
					|
				<b-button class="p-0 error" id="editButton" variant="outline" @click="toggleRatingField(true)" v-b-tooltip.hover>Edit</b-button>
					|
				<b-button class="p-0 error" id="deleteButton" variant="outline" @click="toggleRatingField(true)" v-b-tooltip.hover >Delete</b-button>
				<b-popover target="editButton" triggers="click blur" placement="top" title="How helpful was this suggested message?" v-if="showRatingField">
					<b-form-rating v-model="ratingValue" variant="warning" class="mb-2" @change="editAutoMsg(message)"></b-form-rating>
				</b-popover>
				<b-popover target="deleteButton" triggers="click blur" placement="top" title="How helpful was this suggested message?" v-if="showRatingField">
					<b-form-rating v-model="ratingValue" variant="warning" class="mb-2" @change="deleteAutoMsg(message)"></b-form-rating>
				</b-popover>
			</div>	
				<b-popover target="ratingButton" triggers="click blur" placement="top" title="How helpful was this suggested message?" v-if="showRatingField">
					<b-form-rating v-model="ratingValue" variant="warning" class="mb-2" @change="sendAutoMsg"></b-form-rating>
				</b-popover>
		</div>
				<!-- </p> -->
				<div class="user-info-box" :class="{'row-reverse': message.Inbound}">
					<div v-if="message.Scheduled">
						<span style="font-size:14px">Scheduled for {{$parsePlainDate(message.SendOn)}} at {{$parsePlainTime(message.SendOn)}} <span style="text-decoration:underline;cursor: pointer" @click="cancelMessage(message)">Cancel</span></span>
					</div>
					<div v-else >
					<span v-if="!message.Inbound && message.hasOwnProperty('Clicked') && message.ShortenedLinksCount && message.ShortenedLinksCount > 0" class="text-left">
					<v-icon
						scale="1"
						name="link"
						height="20"
						:class="message.Clicked ? 'text-blue' : 'text-gray'"
						id="linkButton"
						v-b-popover.hover.top.html="
							`<div style='display: flex; flex-direction: column;font-size:12px'>
							<div>
								<label><strong>Links Identified:</strong></label>
								<span>${message.ShortenedLinksCount ? message.ShortenedLinksCount : '-'}</span>
							</div>
							<div>
								<label><strong>Prospect Clicks:</strong></label>
								<span>${message.ClickCount ? message.ClickCount : '-'}</span>
							</div>
							<div>
								<label><strong>Prospect Last Clicked:</strong></label>
								<span>${message.LastClicked ? lastClickedTime : '-'}</span>
							</div>
							</div>`"
						/>
					</span>
					<span v-if="message.ErrorCode" class="text-danger errorInfo" 
					v-b-popover.hover.top.html="`
						<div class='error-info'>
							<div>
								<label><strong>Error Name:</strong> ${message.ErrorName ? message.ErrorName : '-'}</label>
							</div>
							<div>
								<label><strong>Error Description:</strong> ${message.ErrorDescription ? message.ErrorDescription : '-'}</label>
							</div>
							<div>
								<label><strong>Error Solution:</strong> ${message.ErrorSolution ? message.ErrorSolution : '-'}</label>
							</div>
						</div>`"
					>Error Info
				</span>
					</div>
					<div class="">
						<v-icon v-if="message.Status == 'Sending'" name="sync" spin />
					<div v-else-if="message.Status == 'Failed'" class="text-danger">
						<b-button class="p-0 error" variant="outline" @click="$emit('resend')" pill>Resend</b-button>
						|
						<b-button class="p-0 error" variant="outline" @click="$emit('delete')" pill>Delete</b-button>
					</div>
					<span v-else> <span v-if="!message.Inbound && message.Author" class="text-blue">{{ message.Author }}</span> {{time}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { getMediaDetails,sendMessage,db } from 'src/db'
	import axios from "axios";
	import { mapState } from 'vuex'
	// import EmailModal from "./EmailModal.vue";
	export default {
		name: 'Message',
		props: {
			message: {
				Body: String,
				Date: String,
				Status: String,
				Inbound: Boolean,
				loader:Boolean,
				Title:String,
				From:String,
				To:String,
				Notes:String,
				Duration:Number,
				DateCreated:String,
				Auto:Boolean,
				Author:String,
				Clicked:Boolean,
				ClickCount:Number,
				LastClicked:String,
				ShortenedLinksCount:String,
				ErrorCode:Number,
				ErrorName:String,
				ErrorDescription:String,
				ErrorSolution:String
			},
			testAutoConvotemp:Object
		},
		computed: {
			getClassName() {
				if (this.message.Inbound) {
					return 'text-blue'
				}else {
					return 'text-white'
				}
			},
			hasMediaUrl() {
				let value =  false;
				value =  (Object.keys(this.message).includes('mediaUrl') && this.message.mediaUrl);
				if (this.message.SmsStatus === 'cancelled') {
					return false;
				}
				if(value && this.message.Inbound) {
					this.getInBoundSMSType();
				}
				return value
			},
			isImage() {
				let value =  false;
				if (this.message.Inbound) {
					if (this.InboundMediaType) {
						let type = this.InboundMediaType.split('/');
						if (this.imageFormatArray.includes(type[1])) {
							value = true;
						}
					}
				}else {
					// value = this.message.mediaUrl.includes('jpg','jpeg','png','gif','bmp');
					this.imageFormatArray.forEach(element => {
						if (this.message.mediaUrl.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isAudio() {
				let value =  false;
				if (this.message.Inbound) {
					if (this.InboundMediaType) {
						let type = this.InboundMediaType.split('/');
						if (this.audioFormatArray.includes(type[1])) {
							value = true;
						}
					}
				}else {
					// value = this.message.mediaUrl.includes('basic','L24','mp4');
					this.audioFormatArray.forEach(element => {
						if (this.message.mediaUrl.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isVideo() {
				let value =  false;
				if (this.message.Inbound) {
					if (this.InboundMediaType) {
						let type = this.InboundMediaType.split('/');
						if (this.videoFormatArray.includes(type[1])) {
							value = true;
						}
					}
				}else {
					// value = this.message.mediaUrl.includes('webm','mpeg','3gpp');
					this.videoFormatArray.forEach(element => {
						if (this.message.mediaUrl.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isDocument() {
				let value =  false;
				if (this.message.Inbound) {
					if (this.InboundMediaType) {
						let type = this.InboundMediaType.split('/');
						if (this.documentFormatArray.includes(type[1])) {
							value = true;
						}
					}
				}else{
					// value = this.message.mediaUrl.includes('pdf','vcard','csv');
					this.documentFormatArray.forEach(element => {
						if (this.message.mediaUrl.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			time() {
				if (this.message.Date) {
					if (this.isNotToday(this.message.Date)) {
						return this.$parsePlainDate(this.message.Date) + ' ' + this.$parsePlainTime(this.message.Date);
					}else {
						return this.$parsePlainTime(this.message.Date);
					}
					// return this.$parseDate(this.message.Date);
				}
				if (this.message.DateCreated) {
					if (this.isNotToday(this.message.DateCreated)) {
						return this.$parsePlainDate(this.message.DateCreated) + ' ' + this.$parsePlainTime(this.message.DateCreated);
					}else {
						return this.$parsePlainTime(this.message.DateCreated);
					}
				}
				
				return null
			},
			lastClickedTime(){
				if (this.message.LastClicked) {
					if (this.isNotToday(this.message.LastClicked)) {
						return this.$parsePlainDate(this.message.LastClicked) + ' ' + this.$parsePlainTime(this.message.LastClicked);
					}else {
						return this.$parsePlainTime(this.message.LastClicked);
					}
				}
				return null
			},
			getConvertedText() {
				if (this.message.hasOwnProperty('Subject')) {
					// return '<b-button variant="primary">'+this.message.Subject+ '<b-badge variant="light">4</b-badge></b-button>'
					// return '<a href=""'+'target="_blank"'+'>' + this.message.Subject + '</a>';
					// return '<b-button variant="'+'primary'+'" >'+this.message.Subject+'</b-button>'
					
					return '<v-icon name="envelope" scale="3" class="text-blue" />'
				}
				if (this.message.hasOwnProperty('Title')) {		
					return '<v-icon name="phone-square-alt" scale="3" class="text-blue" />'
				}else {
					var urlRegex = /(https?:\/\/[^\s]+)/g;
					if (this.message.SmsStatus == 'cancelled') {
						return
					}else {
						return this.message.Body.replace(urlRegex, function(url) {
							return '<a href="' + url + '"'+'target="_blank"'+'>' + url + '</a>';
						});
					}
				}
			},
			checkIfEmailData() {
				let sub = '';
				if (this.message.hasOwnProperty('Subject')) {
					sub =  this.message.Subject;
				}
				return sub
			},
			checkIfCallsData() {
				let tit = '';
				if (this.message.hasOwnProperty('Title')) {
					tit =  this.message.Title;
				}
				return tit
			},
			getEmptyBodyWithURL() {
				let val = false;
				if (this.message.mediaUrl) {
					if (this.message.SmsStatus === 'cancelled') {
						return false;
					}
					if (this.message.hasOwnProperty('Scheduled') && !this.message.Scheduled) {
						val = false;
					}
					if(this.message.hasOwnProperty('Auto') && !this.message.Auto){
						val = false;
					}
					else {
						val = true;
					}
				}
				return val
			},
			getColorStyle() {
				// message.Status == 'Failed' ? 'bg-danger' : message.Inbound ? 'bg-light' : 'blue text-white'
				return this.message.Status == 'Failed' ? 'bg-danger' : this.message.Inbound ? 'bg-light' : this.message.ErrorCode ? 'bg-danger' : this.message.Auto ? 'green text-white' : this.message.Scheduled ? 'green text-white' : 'blue text-white'
				
			},
			...mapState('globals', ['activeConvo', 'activeProsp']),
			...mapState('firebase', ['prospects', 'convos', 'user','messages'])
			
		},
		components: {
			// EmailModal,
        },
		methods:{
			getInBoundSMSType() {
				let data = this.message.mediaUrl.split('/');
				getMediaDetails({messageId:data[7],mediaId:data[9]})
				.then((res) => { this.getContentType(res)})
				.catch(err => alert(`Failure getting inbound sms URL: ${err}`));
			},
			getContentType(res) {
				const items =  JSON.parse(res.data);
				this.InboundMediaType = items.contentType;
			},
			cancelMessage(smsDetail) {
				if (confirm("Are you sure you want to cancel this scheduled message?")) {
					this.message.loader = true;
					this.$emit('cancelClick', true);
					const smsData = {
						pid:this.user.id,
						cid:this.activeProsp,
						SmsId:smsDetail.SmsId
					};
					axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/cancelSms", smsData)
					.then(response => {
							// eslint-disable-next-line
						console.log(response);
						this.message.loader = false;
						this.$emit('cancelClick', false);
						this.mediaUrl = "";
						this.$store.dispatch('firebase/rebindConvosScheduledCount', {
							uid: this.user.Uid,
							id: this.user.id,
						})
					});
				}
			},
			isNotToday(milliseconds) {
				let date = new Date(parseInt(milliseconds));
				let now = new Date();
				if (date.getFullYear() === now.getFullYear() &&
					date.getMonth() === now.getMonth() &&
					date.getDate() === now.getDate()) {
					return false;
				}
				return true;
			},
			openEmailModal() {
				let emailDetailsObject = {
						user:this.user,
						// prospect:this.prospect
						message:this.message,
						type:'fromSingle'
					}
				this.emailData = emailDetailsObject;
				this.$bvModal.show('EmailModal');
			},
			toggleRatingField(show) {
				if (!this.ratingValue) {
					this.showRatingField = show;
				}
			},
			toggleLinkField(show){
				this.linkShow = show
			},
			editAutoMsg(message){
				setTimeout(() => {	
					this.showRatingField = false;
				}, 200);
				setTimeout(() => {
					if (this.ratingValue !== null){
					this.$emit('editMessage', message,this.ratingValue);
					this.showRatingField = true;
					this.ratingValue=null;
				}
				}, 300);
			},
			deleteAutoMsg(message){
				setTimeout(() => {	
					this.showRatingField = false;
				}, 200);
				setTimeout(() => {
					if (this.ratingValue !== null){
					this.$emit('deleteMessage', message,this.ratingValue)
				}
				}, 300);	
			},
			sendAutoMsg() {
				setTimeout(() => {	
					this.showRatingField = false;
				}, 200);
				setTimeout(() => {
					if (this.ratingValue !== null){
						this.$set(this.tempAutoConvo.sending, this.tempAutoConvo.id, {Body: this.tempAutoConvo.Body, Date: new Date(), Incoming: false,Auto :true,Status: 'Sending'});
						sendMessage({ 	 	 	
						To: this.tempAutoConvo.To,
						Body: this.tempAutoConvo.Body,
						mediaUrl:this.tempAutoConvo.mediaUrl,
						Uid:this.tempAutoConvo.Uid
					}).catch(()=>{
						this.$set(this.tempAutoConvo.sending, this.tempAutoConvo.id, {Body: this.tempAutoConvo.Body, Date: new Date(), Incoming: false,Auto :true,Status: 'Failed'});
						this.$delete(this.tempAutoConvo.sending,this.tempAutoConvo.id);
					}).finally(async() => {
						let autoMessageDB={
							Message:this.tempAutoConvo.Body,
							Rating:this.ratingValue,
							Date:Date.now(),
							Uid:this.tempAutoConvo.Uid
						}	
						await db.collection('Generated').add(autoMessageDB);
						this.$delete(this.tempAutoConvo.sending,this.tempAutoConvo.id);
						this.message.Auto=false;
						this.tempAutoConvo={};
					})
				}
				}, 300);
			},
			async deleteErrorMessage(){
				await db.doc(`Conversations/${this.activeConvo}/Messages/${this.message.id}`).delete();
				const totalErrorCodes = this.messages.filter(m=>m.ErrorCode).length;
				await db.doc(`Conversations/${this.activeConvo}`).update({Errors:totalErrorCodes});
				this.$store.dispatch('firebase/rebindConvosErroredCount', {
					uid: this.user.Uid,
					id: this.user.id,
				})
			}
		},
		data() {
			return {
				showRatingField: true,
				tempAutoConvo: this.testAutoConvotemp,
				ratingValue: null,
				linkShow:true,
				emailData:{},
				InboundMediaType:'',
				imageFormatArray:['jpg','jpeg','png','gif','bmp','PNG','JPG','JPEG'],
				audioFormatArray:['basic','L24','mpeg','ogg','vorbis','vnd.rn-realaudio','vnd.wave','3gpp','3gpp2','ac3','vnd.wave','amr-nb','amr'],
				videoFormatArray:['webm','mpeg','mp4','3gpp','quicktime','3gpp2','3gpp-tt','H261','H263','H263-1998','H263-2000','H264',],
				documentFormatArray:['pdf','vcard','csv','rtf','richtext','calendar','directory']

			}
		}
	}
</script>

<style scoped>
	button.error {
		color: inherit;
		font-size: .7em;
		box-shadow: none;
	}
	button.error:active {
		color: pink;
		text-decoration: underline;
	}
	.message {
		font-size: 1.1em;
		display: inline-block;
		max-width: 80%;
		padding: 8px 10px;
		white-space: pre-line;
		box-shadow: 1px 1px 1px lightgray;
	}
	.message1 {
		font-size: 1.1em;
		display: inline-block;
		/* max-width: 80%; */
		padding: 8px 10px;
		white-space: pre-line;
		box-shadow: 1px 1px 1px lightgray;
	}
	.green {
		background-color:#385723;
	}
	.email-icon svg{
		width: 20px !important;height: auto !important;
	}
	.email-icon{
		margin-right: 10px;
	}
	.custom-email-button button{
		padding:0px 5px !important;
		font-size: 14px;
	}
	.error-info{
		display: flex;
		flex-direction: column;
		max-width: 250px;
	}
	.errorInfo{
		margin-left: 5px;
	}
	.message-layout-box {
		/* font-size: 1.1em; */
		display: inline-block;
		max-width: 80%;
	}
	.user-info-box {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		padding: 0px 20px 0px 5px;
	}
	.user-info-box.row-reverse {
		flex-direction: row-reverse;
	}
</style>